module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('message-system', {
    attrs: {
      "size": "small"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": _vm.icon,
      "alt": "Piscicultura Global"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("\n        El éxito está compuesto por dos factores, preparación y oportunidad.\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("\n        Hoy asumes el reto de prepararte con nosotros, juntos crearemos nuestras oportunidades y el éxito será inevitable.\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Bienvenido a tu curso.")]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticClass: "button is-medium is-piscicultura",
    attrs: {
      "href": _vm.blog_url
    }
  }, [_vm._v("\n        Ir al Blog\n      ")]), _vm._v("\n       \n      "), _c('a', {
    staticClass: "button is-medium is-success",
    attrs: {
      "href": _vm.course.external
    }
  }, [_vm._v("\n        Ir al Curso\n      ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-158063de","hasScoped":false}!./src/pages/course-congratulation/template.html
// module id = 398
// module chunks = 1